/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     入口脚本 main.js
  +--------------------------------------------------------------------------------------
*/

import Vue from 'vue'
import router from './router/router'
import store from './store/store'
import App from './App.vue'

// Element UI
import Element from 'element-ui'
import './styles/index.scss'
import "./iconfont/iconfont.css";
import "./iconfont/iconfont.js";
Vue.use(Element, { size: 'medium' })

// vue-photo-preview
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

// vue-count-to
import CountTo from 'vue-count-to'
Vue.component('CountTo', CountTo)

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

// 全局自定义组件注册
import FBack from './components/FBack'
import FDatePicker from './components/FDatePicker'
import FMonthPicker from './components/FMonthPicker'
import FDateRangePicker from './components/FDateRangePicker'
import FSearchInput from './components/FSearchInput'
import FRadioBtnGroup from './components/FRadioBtnGroup'
import FTagSelector from './components/FTagSelector'
import FDevSelector from './components/FDevSelector'
import FEquipSelector from './components/FEquipSelector'
import FMemberSelector from './components/FMemberSelector'
import FSortSelector from './components/FSortSelector'
import FDevName from './components/FDevName'
import FEquipAvatar from './components/FEquipAvatar'
import FEquipName from './components/FEquipName'
import FImage from './components/FImage'
import FPagination from './components/FPagination'
import FTableFooter from './components/FTableFooter'
import FUserAvatar from './components/FUserAvatar'
import FUserName from './components/FUserName'
import RmsMemberActiveCurve from './components/RmsMemberActiveCurve'
import FCertifiedComfirm from './components/FCertifiedComfirm'
import FNumberUnit from "@/components/FNumberUnit/index.vue"
import FAreaMultiplePicker from "@/components/FAreaMultiplePicker/index.vue"
Vue.component('FBack', FBack)
Vue.component('FDatePicker', FDatePicker)
Vue.component('FMonthPicker', FMonthPicker)
Vue.component('FDateRangePicker', FDateRangePicker)
Vue.component('FSearchInput', FSearchInput)
Vue.component('FRadioBtnGroup', FRadioBtnGroup)
Vue.component('FTagSelector', FTagSelector)
Vue.component('FDevSelector', FDevSelector)
Vue.component('FEquipSelector', FEquipSelector)
Vue.component('FMemberSelector', FMemberSelector)
Vue.component('FSortSelector', FSortSelector)
Vue.component('FDevName', FDevName)
Vue.component('FEquipAvatar', FEquipAvatar)
Vue.component('FEquipName', FEquipName)
Vue.component('FImage', FImage)
Vue.component('FPagination', FPagination)
Vue.component('FTableFooter', FTableFooter)
Vue.component('FUserAvatar', FUserAvatar)
Vue.component('FUserName', FUserName)
Vue.component('RmsMemberActiveCurve', RmsMemberActiveCurve)
Vue.component('FNumberUnit', FNumberUnit)
Vue.component('FAreaMultiplePicker', FAreaMultiplePicker)
import FContactUs from './components/FContactUs/index.js'
Vue.use(FContactUs)
import FEquipDetail from './components/FEquipDetail/index.js'
Vue.use(FEquipDetail)
import FMemberDetail from './components/FMemberDetail/index.js'
Vue.use(FMemberDetail)
// Echarts
import echarts from 'echarts'
import teenager from '@/components/FCharts/theme/teenager'
echarts.registerTheme('teenager', teenager)
Vue.prototype.$echarts = echarts


// 注册全局组件
Vue.prototype.$fCertifiedConfirm = function(options) {
  const confirmInstance = new Vue(FCertifiedComfirm).$mount();
  return confirmInstance.showConfirm({ ...options, router });
};

// Permission
import './permission'

// Global Filter
import * as filters from './filters/filter'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 自定义指令
import './directive/overflow-tooltip'

// Utils
import * as storage from './utils/storage'

Vue.prototype.$utils = {
  saveListQuery: storage.saveListQuery,
  initListQuery: storage.initListQuery,
}
Vue.config.productionTip = false
Vue.config.devtools = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
